export default defineNuxtPlugin(() => {
  if (process.client) {
    // Перехватываем клики на ссылки к статическим файлам
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement
      const link = target.closest('a') || (target.tagName === 'A' ? target : null)
      
      if (link && (link as HTMLAnchorElement).href) {
        const url = new URL((link as HTMLAnchorElement).href, window.location.origin)
        const pathname = url.pathname
        
        // Проверяем, является ли это статическим файлом
        const staticFileExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.svg', '.webp', '.ico', '.css', '.js', '.json', '.xml', '.txt', '.webm', '.mp4', '.mp3', '.zip', '.rar', '.woff', '.woff2', '.ttf', '.otf']
        const hasFileExtension = staticFileExtensions.some(ext => pathname.toLowerCase().endsWith(ext))
        
        // Если это тот же домен и статический файл, открываем напрямую
        if (hasFileExtension && url.origin === window.location.origin) {
          e.preventDefault()
          window.location.href = pathname + (url.search || '') + (url.hash || '')
        }
      }
    }, true) // Используем capture phase для перехвата до Nuxt
  }
})

